import { BackArrowIcon } from "@/assets/icons/admin";
import CustomChipDropdown from "@/components/admin/chipdropdown";
import {
  useAddBulkReferrals,
  useGetAllUserName,
  useGetSpecialReferrals,
} from "@/services/admin.service";
import { Button, Input, Textarea } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

interface AddNewRefProps {
  onCancel: () => void;
}

const AddNewRef: React.FC<AddNewRefProps> = ({ onCancel }) => {
  const [chipViewHeight, setChipViewHeight] = useState(0);

  const { data: getAllUserNames } = useGetAllUserName({
    page: 1,
    pageSize: 10,
  });

  const userNames =
    getAllUserNames?.data?.data.map((item: { userName: any; id: any }) => ({
      label: item.userName,
      value: item.id,
    })) || [];

  const userNameOptions = userNames.map((name: any) => name.label);

  const [selectedNames, setSelectedNames] = useState<string[] | undefined>();
  const [specialRate, setSpecialRate] = useState<number>(0);
  const [reason, setReason] = useState<string>("");
  const [userIds, setUserIds] = useState<string[]>([]);

  // Function to get IDs for selected names
  const getSelectedIds = () => {
    return userNames
      .filter((user: { label: string }) => selectedNames?.includes(user.label))
      .map((user: { value: any }) => user.value);
  };

  const handleSpecialRateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Convert input value to a number
    const value = parseFloat(e.target.value);
    setSpecialRate(isNaN(value) ? 0 : value); // Handle case where conversion fails
  };

  useEffect(() => {
    const ids = getSelectedIds();
    setUserIds(ids);
  }, [selectedNames, specialRate, reason]);
  const { refetch } = useGetSpecialReferrals({ page: 1, pageSize: 10 });

  const addReferrals = useAddBulkReferrals();
  const handleSave = () => {
    addReferrals.mutate(
      {
        reason,
        specialRate,
        userIds,
      },
      {
        onSuccess: () => {
          console.log("Added referrals");
          refetch();
          toast.success("Added referrals");
        },
        onError: (error: any) => {
          toast.error("Adding referrals failed");
          console.log("Self-exclusion request failed!");
          console.log(error);
        },
      },
    );
  };

  return (
    <>
      <div>
        <div className="font-ubuntu mb-4 w-full text-center text-2xl font-semibold text-white sm:float-left">
          <span>
            <Button
              isIconOnly
              onClick={onCancel}
              className="transparent-bg float-left ml-[-11px] h-auto w-auto"
            >
              <BackArrowIcon />
            </Button>
            <p className="float-left text-xl">Add Special Referral</p>
          </span>
        </div>
        {/* Input form */}
        <div className="flex w-full flex-col pt-2">
          <div className="flex flex-col">
            <div className="mt-1 basis-full sm:mt-0 sm:basis-full">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Select Players
              </label>
              <div className="flex-grow">
                <CustomChipDropdown
                  options={userNameOptions}
                  setSelectedPrivileges={setSelectedNames}
                  onChipViewHeightChange={setChipViewHeight}
                  placeholder="Search player by name or email"
                  enableFilter={true}
                />
              </div>
            </div>
            <div
              className={`basis-full sm:basis-full`}
              style={{
                marginTop: chipViewHeight ? `${chipViewHeight + 10}px` : "10px",
              }}
            >
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Special Rates (%)
              </label>
              <Input
                type="number"
                name="rate"
                onChange={handleSpecialRateChange}
                className={`input-bg w-full !cursor-text rounded-md border border-solid sm:w-full`}
                classNames={{
                  inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
                }}
                placeholder="Type Here"
              ></Input>
            </div>
            <div className="mt-4 basis-full sm:basis-full">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Reason
              </label>
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className={`input-bg !cursor-text rounded-md border border-solid`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "bg-white-5",
                    "reason-text-field-height",
                    "text-sm",
                  ],
                }}
                variant="bordered"
                placeholder="Type Here"
              />
            </div>
            <div className="mt-4 basis-1/2 ">
              <div className="sm:float-right">
                <Button
                  onClick={handleSave}
                  className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-20 pr-20 text-base font-bold"
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewRef;
